/**
 * https://www.pdftron.com/api/web/Core.html#syncNamespaces__anchor
 */
export default (namespaces) => window.Core.syncNamespaces(namespaces);
